import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'hooks';
import { UserRole } from 'store/user/types/state.types';
import profileService from 'services/api/customer/profile-service';
import DropdownSelector from 'components/UI_kit_3/DropdownSelector/DropdownSelector';

// eslint-disable-next-line react/prop-types
const LanguageSelector:React.FC<React.HTMLProps<HTMLDivElement>> = ({ className }) => {
  const [, i18n] = useTranslation();
  const user = useAppSelector((state) => state.user);
  const langs = React.useMemo(() => [
    {
      value: 'ru',
      label: 'Ru',
    },
    {
      value: 'en',
      label: 'En',
    },
  ], []);

  const handleSelect = (value: string | number | null) => {
    if (value) {
      i18n.changeLanguage(value.toString());
      localStorage.setItem('pdlang', value.toString());
      if (user.role !== UserRole.Guest) {
        profileService.setLanguage(value.toString());
      }
    }
  };

  React.useEffect(() => {
    if (user.language && user.language !== i18n.language) {
      i18n.changeLanguage(user.language);
      localStorage.setItem('pdlang', user.language);
    }

    if (user.token && user.language === null) {
      profileService.setLanguage(i18n.language);
    }
  }, [user]);
  return (
    <DropdownSelector
      className={`language-selector${className ? ` ${className}` : ''}`}
      value={i18n.language}
      data={langs}
      onChange={handleSelect}
      qaElement="language-selector"
    />
  );
};

export default LanguageSelector;
